import { useMutation, useQueryClient } from '@tanstack/react-query';
import dailySiteReportService from '@services/dailySiteReport';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import { DailySiteReportOrganizationSettingsInput } from '@models/dailySiteReport.model';
import { DAILY_SITE_REPORT_SETTINGS_QUERY_KEY } from './useDailySiteReportSettings';
import { MY_DAILY_SITE_REPORTS_QUERY_KEY } from './useMyDailySiteReports';
import { DAILY_SITE_REPORT_QUERY_KEY } from './useDailySiteReport';

export const useDailySiteReportMutations = () => {
  const queryClient = useQueryClient();
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  const updateOrganizationSettings = useMutation({
    mutationFn: (input: DailySiteReportOrganizationSettingsInput) =>
      dailySiteReportService.updateDailySiteReportOrganizationSettings(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [DAILY_SITE_REPORT_SETTINGS_QUERY_KEY, organizationId] });
    },
  });

  const sendNow = useMutation({
    mutationFn: () => dailySiteReportService.sendMyDailySiteReportNow(),
    onSuccess: async (report) => {
      queryClient.setQueryData([DAILY_SITE_REPORT_QUERY_KEY, organizationId, report.reportId], report);
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [MY_DAILY_SITE_REPORTS_QUERY_KEY, organizationId] }),
        queryClient.invalidateQueries({ queryKey: [DAILY_SITE_REPORT_SETTINGS_QUERY_KEY, organizationId] }),
      ]);
    },
    // No onError toast here (story-207, D3): the caller owns the single, translated message.
  });

  return { updateOrganizationSettings, sendNow };
};

export default useDailySiteReportMutations;
